"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPermissionsComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const roles_service_1 = require("./roles.service");
const permission_service_1 = require("./permission.service");
const permissions_service_1 = require("./permissions.service");
const notification_service_1 = require("./notification.service");
const order_by_pipe_1 = require("./order-by.pipe");
const app_service_1 = require("./app.service");
let AdminPermissionsComponent = class AdminPermissionsComponent {
    constructor(_app, _talk, _admin, _cd, _permission, _permissions, _roles, _orderBy, _router) {
        this._app = _app;
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._permission = _permission;
        this._permissions = _permissions;
        this._roles = _roles;
        this._orderBy = _orderBy;
        this._router = _router;
        this.searchTerm = '';
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.permissions = this._permissions.get();
        for (var p in this.permissions) {
            this.permissions[p].selected = false;
        }
        this.roles = this._orderBy.transform(this._roles.get(), ['+type']);
        switch (true) {
            case this.roles && this.roles.length > 0:
                this.selectedRole = { id: this.roles[0].id, displayName: this.roles[0].displayName };
                this.setRole(this.selectedRole.id);
                this.mapPermissions();
            case this.roles && this.roles.length > 1:
                for (var r = 1; r < this.roles.length; r++) {
                    this.roles[r].selected = false;
                }
        }
    }
    setRole(role) {
        for (var r in this.roles) {
            if (this.roles[r].id == role) {
                this.roles[r].selected = true;
            }
            else {
                this.roles[r].selected = false;
            }
        }
    }
    selectRole(role) {
        this.selectedRole = { id: role.id, displayName: role.displayName };
        this.setRole(role.id);
        this.mapPermissions();
    }
    mapPermissions() {
        permLoop: for (var p in this.permissions) {
            for (var r in this.permissions[p].roles) {
                if (this.permissions[p].roles[r].id == this.selectedRole.id) {
                    this.permissions[p].selected = true;
                    continue permLoop;
                }
            }
            this.permissions[p].selected = false;
        }
        this._cd.markForCheck();
    }
    mapPermissionsToRole() {
        //fill array with selected permissions ids to updates associations
        const permArray = this.permissions.filter(p => !!p.selected).map(p => p.id);
        //call to update role
        Promise.resolve(this._admin.updateRole(this.selectedRole.id, permArray)).then(err => {
            Promise.resolve(this._permissions.pull()).then(err => {
                this.permissions = this._permissions.get();
                this.mapPermissions();
                this._cd.markForCheck();
                let runInit = this._talk.confirm(`Permissions for ` + this.selectedRole.displayName + ` have been updated. Would you like to refresh the app so that new permissions can take effect?`);
                runInit.then(resultPromise => {
                    if (resultPromise.result)
                        return resultPromise.result
                            .then(result => {
                            if (result)
                                this._app.init('/admin', false);
                            this._router.navigate(['/refresh']);
                        }).catch(err => { return true; });
                }).catch(err => { return true; });
            }).catch(err => { return true; });
        }).catch(err => { return true; });
    }
};
exports.AdminPermissionsComponent = AdminPermissionsComponent;
exports.AdminPermissionsComponent = AdminPermissionsComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-permissions',
        templateUrl: 'app/admin-permissions.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [app_service_1.AppService,
        notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        permission_service_1.PermissionService,
        permissions_service_1.PermissionsService,
        roles_service_1.RolesService,
        order_by_pipe_1.OrderByPipe,
        router_1.Router])
], AdminPermissionsComponent);
//# sourceMappingURL=admin-permissions.component.js.map